<BI-grid-layout [cols]="['100%']" [gap]="3">
    <BI-grid-layout-item [row]="1" [col]="1">
        <div class="nav-btns-container d-flex justify-content-start">
            <div [dir]="biService.getDir() ? 'rtl': 'ltr'" class="justify-content-between d-flex text-center px-0">
                <button *ngIf="navButtons.add?.visibility || !navButtons?.add" kendoButton
                    [id]="'Add_Bi_Attachment_Nav'" [disabled]="!data.CanAddAttachments" fillMode="none"
                    class="nav-btn px-1" (click)="fileInput.click()" imageUrl="assets/icons/add_black_24dp.svg">
                    <div class="mobile-hidden">{{"add"|translate}}</div>
                </button>
                <button *ngIf="!navButtons?.save || navButtons.save?.visibility" kendoButton
                    [id]="'Save_Bi_Attachment_Nav'" fillMode="none"
                    [ngClass]="{'nav-save-btn': (navButtons.add?.visibility || !navButtons.add)}" class="nav-btn"
                    (click)="Save()" value="Save" imageUrl="assets/icons/save_black_24dp (2).svg">
                    <div class="mobile-hidden">{{"Save" | translate}}</div>
                </button>
                <button *ngIf="!navButtons?.delete || navButtons.delete?.visibility" kendoButton
                    [id]="'Delete_Bi_Attachment_Nav'" [disabled]="!data.CanDeleteAttachments" fillMode="none"
                    class="nav-delete-btn nav-btn px-1" (click)="DeleteRow()" imageUrl="assets/icons/delet.svg">
                    <div class="mobile-hidden">{{"Delete"|translate}}</div>
                </button>
                <button *ngIf="!navButtons?.cancel || navButtons.cancel?.visibility" kendoButton
                    [id]="'Cancel_Bi_Attachment_Nav'" fillMode="none"
                    [ngClass]="{'nav-cancel-btn': (!navButtons.delete || navButtons.delete?.visibility)}"
                    class="nav-btn" (click)="Cancel()" imageUrl="assets/icons/cancel_black_24dp (2).svg">
                    <div class="mobile-hidden">{{"Cancel"|translate}}</div>
                </button>
                <button [disabled]="!data.CanViewAttachments" kendoButton fillMode="none" class="nav-btn px-1"
                    (click)="Download()" imageUrl="assets/images/downloadIcon.svg">
                    <div class="mobile-hidden nav-btn">{{"Download"|translate}}</div>
                </button>
                <button [disabled]="!data.CanViewAttachments||!isImage" kendoButton fillMode="none" class="nav-btn px-2"
                    (click)="View()" imageUrl="assets/icons/View.svg">
                    <div class="mobile-hidden">{{"View"|translate}}</div>
                </button>
            </div>
        </div>
    </BI-grid-layout-item>
    <BI-grid-layout-item class="main" [row]="2" [col]="1">
        <BI-Grid #Header [DataService]="SA_Attachments_DataSource" [changeSet]="SA_Attachments_changeset"
            (RowChange)="HeaderRowChange()" [Columns]="SA_Attachments_columns">
        </BI-Grid>
    </BI-grid-layout-item>
</BI-grid-layout>

<ff-alerts></ff-alerts>

<input type="file" #fileInput (change)="UploadFile($event)">

<kendo-dialog [title]="BIGrid.GetValueOf('FileName')" *ngIf="isViewClicked" (close)="ViewCanceled()" [maxWidth]="500">
    <div class="file-item">
        <img class="img-preview" [src]="sanitizer.bypassSecurityTrustResourceUrl(UploadedFile)" />
    </div>
</kendo-dialog>